(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(() => {
  const storageKey = 'lauren_castell_cart_deadline_v1';
  let memoryDeadline = 0;
  let hadItems = false;
  const readDeadline = () => {
    try { return Number(sessionStorage.getItem(storageKey)) || memoryDeadline; }
    catch { return memoryDeadline; }
  };
  const saveDeadline = value => {
    memoryDeadline = value;
    try { if (value) sessionStorage.setItem(storageKey, String(value)); else sessionStorage.removeItem(storageKey); }
    catch {}
  };
  const tick = () => {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    const timer = drawer.querySelector('[data-lc-timer]');
    if (!timer || drawer.classList.contains('is-empty')) {
      if (hadItems) { saveDeadline(0); hadItems = false; }
      return;
    }
    hadItems = true;
    let deadline = readDeadline();
    const rect = drawer.getBoundingClientRect();
    const visible = getComputedStyle(drawer).visibility !== 'hidden' && rect.left < innerWidth && rect.right > 0 && rect.width > 0;
    if (!deadline && visible) { deadline = Date.now() + 600000; saveDeadline(deadline); }
    if (!deadline) return;
    const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
    const clock = timer.querySelector('[data-lc-clock]');
    const expired = timer.querySelector('[data-lc-expired]');
    const message = timer.querySelector('span');
    if (clock) { clock.textContent = String(Math.floor(remaining / 60)).padStart(2, '0') + ':' + String(remaining % 60).padStart(2, '0'); clock.hidden = remaining === 0; }
    if (message) message.hidden = remaining === 0;
    if (expired) expired.hidden = remaining !== 0;
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('.lc-upsell-prev, .lc-upsell-next');
    if (!button) return;
    const scroller = button.closest('.cart-drawer__upsell').querySelector('.cart-upsell');
    if (!scroller) return;
    const direction = button.classList.contains('lc-upsell-next') ? 1 : -1;
    scroller.scrollBy({left: direction * (scroller.clientWidth + 12), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  });
  tick();
  setInterval(tick, 1000);
})();

  } catch(e) { console.error(e); }
})();
})();
